<form [formGroup]="form" class="time-picker-container">
  <span class="input-label">
    {{ headerText }}
    @if (required) {
      <span class="required-field">*</span>
    }
  </span>
  <span class="input-form-control-container">
    <ion-input
      class="form-control"
      [formControlName]="control"
      [disableClick]="true"
      [placeholder]="placeholderText"
      (ionInput)="fixTimeFormat()"
      (ionBlur)="validateTimeOnBlur()"
    ></ion-input>

    <ngx-material-timepicker-toggle
      [for]="picker"
      [ngClass]="{ 'alt-spacing': altIconSpacing }"
    >
      <ion-icon [src]="icon" ngxMaterialTimepickerToggleIcon></ion-icon>
    </ngx-material-timepicker-toggle>

    <ngx-material-timepicker
      #picker
      [defaultTime]="form.get(control)?.value || defaultStartTime"
      [format]="24"
      (timeSet)="inputChanged($event)"
    ></ngx-material-timepicker>
  </span>
</form>
